export default __webpack_public_path__ + "static/media/100_18937.bb4e0651.jpg";